module.exports = __webpack_public_path__ + "img/button.6ea9e346.png";